export async function showBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  try {
    a.href = url
    a.target = '_blank'

    a.download = filename
    document.body.appendChild(a)
  } finally {
    a.click()
    a.remove()

    // Libère la mémoire après utilisation
    setTimeout(() => window.URL.revokeObjectURL(url), 0)
  }
}
